import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';

export default class DuplicatePlaylistDialog extends Component {
  getInitialState = () => ({
    name: '',
    error: null,
    showError: false,
  });

  state = this.getInitialState();

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { show } = nextProps;

    if (!show) {
      this.setState(this.getInitialState());
    }
  }

  onChange = event => {
    const { showError } = this.state;

    this.setState({ name: event.target.value });

    if (showError) {
      this.validate(event.target.value);
    }
  };

  duplicate = () => {
    const { onSuccess } = this.props;
    const { name } = this.state;

    if (this.validate()) {
      onSuccess(name);
    }
  };

  errorClass = error => (error ? 'error' : null);

  validate = value => {
    const { name: stateName } = this.state;
    const plName = value || stateName;
    let error = null;

    if (!plName.trim()) {
      error = 'This field cannot be empty.';
    } else if (!this.isUniqueName(plName)) {
      error = 'This name is already in use.';
    }

    this.setState({ showError: true, error });

    return !error;
  };

  isUniqueName = name => {
    const { playlists } = this.props;

    return !playlists.some(item => {
      const itemName = item.name.toLowerCase().trim();
      const newName = name.toLowerCase().trim();

      return itemName === newName;
    });
  };

  render() {
    const { playlist, show, onHide } = this.props;
    const { name, error } = this.state;

    return (
      <Modal dialogClassName="playlist-dialog" backdrop="static" show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title data-test="modal-duplicateplaylist-title">Duplicate Playlist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Duplicate <b>{playlist.name}</b>. Enter a name for the new Playlist.
          </p>
          <FormGroup validationState={this.errorClass(error)}>
            <FormControl
              data-test="modal-duplicateplaylist-input-name"
              name="name"
              placeholder="Enter a name"
              value={name}
              onChange={this.onChange}
              autoFocus
            />
            <HelpBlock>{error}</HelpBlock>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={onHide}>
            Cancel
          </Button>
          <Button
            data-test="modal-duplicateplaylist-button-duplicate"
            className="btn-add"
            bsStyle="primary"
            onClick={this.duplicate}
          >
            Duplicate Playlist
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DuplicatePlaylistDialog.propTypes = {
  playlists: PropTypes.array,
  playlist: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
